import { ITranslationService } from 'src/Foundation/Translation/platform/app/translation.service';
import { ISFCCProductPrice } from '@gn-audio/core/api/pricing/models';
import { getAvailabilityState } from '@gn-audio/core/api/pricing/utilities';
import { fetchFamily } from '@gn-audio/core/api/product-catalogue/fetch-family';
import { IFamily, IFeature, IGroup } from '@gn-audio/core/api/product-catalogue/models';
import { AvailabilityState } from '@gn-audio/core/common/enums';
import { Component, Inject, Input, OnChanges, SimpleChanges } from 'angular-ts-decorators';
import { CustomizerEvents } from '../models/customizer-events';
import { notifySubscribers } from '../utils/notify-subscribers';

import template from './customizer-product-info.component.html';

@Component({
  selector: 'customizerProductInfo',
  template,
})
export class CustomizerProductInfoComponent implements OnChanges {
  public static $inject: ReadonlyArray<string> = [];

  @Input() public group?: IGroup;
  @Input() public familyId?: number;
  @Input() public features?: IFeature[];
  @Input() public hideFeatures = true;
  @Input() public hideUniqueSellingPoint? = true;
  @Input() public hideUniqueSellingPointOnMobile? = false;
  @Input() public readonly hidePrice? = false;

  public family?: IFamily;
  public groupAvailabilityState?: AvailabilityState;

  constructor(
    @Inject('$q') private readonly $q: ng.IQService,
    @Inject('translation') private readonly translation: ITranslationService,
  ) { }

  public ngOnChanges(changes: SimpleChanges<CustomizerProductInfoComponent>) {
    if (changes.familyId && this.familyId) {
      this.$q
        .when(fetchFamily(this.familyId))
        .then(this.onFamilyLoad.bind(this));
    }
  }

  public get productTitle(): string {
    const buyWord = this.translation.getSystem('Buy');
    const familyName = this.family?.name;
    return `${buyWord} ${familyName}`;
  }

  public onPriceLoaded(price?: ISFCCProductPrice | null) {
    this.groupAvailabilityState = getAvailabilityState(price);
  }

  public get canProductBeBought(): boolean {
    return this.groupAvailabilityState < AvailabilityState.WhereToBuy;
  }

  private onFamilyLoad(family: IFamily) {
    this.family = family;
    notifySubscribers(CustomizerEvents.FamilyLoaded, this.family);
  }
}
